import { compose, filter, map, invert, size, values, flatMap, some, pickBy, startsWith, gt, __ } from 'lodash/fp';
import { ResourceCategoryType } from '@mews-commander/legacy-data-structures';
import { getResourceCategoryTypeOccupancyKey } from '../../occupancy/utils';
import { OCCUPANCY_KEY_PREFIX } from '../../occupancy/constants';
import { FULL_OPACITY, MIN_OPACITY } from './constants';

export function getBars(data: $TSFixMe) {
    const withDataOnly = (resourceCategoryType: $TSFixMe) =>
        some(getResourceCategoryTypeOccupancyKey(resourceCategoryType.value))(data);
    const availableResourceCategoryTypes = filter(withDataOnly)(ResourceCategoryType.enumValues);

    const opacityMultipliers = compose(invert, map('value'))(availableResourceCategoryTypes);

    const availableResourceCategoryTypesCount = size(availableResourceCategoryTypes);
    const opacityStep =
        availableResourceCategoryTypesCount > 1
            ? (FULL_OPACITY - MIN_OPACITY) / (availableResourceCategoryTypesCount - 1)
            : 0;
    return map((resourceCategoryType) => {
        const dataKey = getResourceCategoryTypeOccupancyKey((resourceCategoryType as $TSFixMe).value);
        // @ts-expect-error $TSFixMeError: The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
        const fillOpacity = FULL_OPACITY - opacityMultipliers[(resourceCategoryType as $TSFixMe).value] * opacityStep;
        return {
            resourceCategoryType,
            fillOpacity,
            dataKey,
            key: (resourceCategoryType as $TSFixMe).value,
            name: (resourceCategoryType as $TSFixMe).name,
        };
    })(availableResourceCategoryTypes);
}

export const isOverbooked = gt(__, 100);

export const hasOverbookedValues = compose(
    some(isOverbooked),
    // @ts-expect-error $TSFixMeError: No overload matches this call.
    flatMap((item) => values(pickBy((value, key) => startsWith(OCCUPANCY_KEY_PREFIX, key))(item)))
);
